import {ChecklistPage} from '@features/hroc-checklists'
import {InvertedSurfaceProvider} from '@hconnect/common/styles'
import {useParams} from 'react-router'

type PathParameter = {
  plantId?: string
  checklistId?: string
}

export const TaskChecklistPage = () => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  return (
    <InvertedSurfaceProvider>
      <ChecklistPage plantId={plantId} />
    </InvertedSurfaceProvider>
  )
}
